"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var unavailable_exports = {};
__export(unavailable_exports, {
  Purchases: () => Purchases
});
module.exports = __toCommonJS(unavailable_exports);
var import_validateCallback = require("../validateCallback");
var import_nativeError = require("../nativeError");
var Purchases = Object.freeze({
  getProducts: function getProducts(_productIds) {
    return Promise.resolve([]);
  },
  purchase: function purchase(_productId, _appAccountToken) {
    return Promise.reject((0, import_nativeError.missingNativeBuild)("Purchases.purchase"));
  },
  getCurrentEntitlements: function getCurrentEntitlements() {
    return Promise.reject((0, import_nativeError.missingNativeBuild)("Purchases.getCurrentEntitlements"));
  },
  getUnfinishedTransactions: function getUnfinishedTransactions() {
    return Promise.reject((0, import_nativeError.missingNativeBuild)("Purchases.getUnfinishedTransactions"));
  },
  finishTransaction: function finishTransaction(_transactionId) {
    return Promise.reject((0, import_nativeError.missingNativeBuild)("Purchases.finishTransaction"));
  },
  addTransactionListener: function addTransactionListener(onUpdate) {
    (0, import_validateCallback.validateCallback)(onUpdate, "Purchases.addTransactionListener requires a function");
    return function() {
    };
  },
  sync: function sync() {
    return Promise.reject((0, import_nativeError.missingNativeBuild)("Purchases.sync"));
  }
});
//# sourceMappingURL=unavailable.js.map
